<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：会员-积分管理
  -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="积分明细" name="first"></el-tab-pane>
      <el-tab-pane label="积分设置" name="second"></el-tab-pane>
      <el-tab-pane label="邀请送积分" name="DirectRecommend" v-if="show_DirectRecommend == true"></el-tab-pane>
    </el-tabs>

    <!--积分明细-->
    <Log v-if="activeName == 'first'"></Log>
    <!--积分设置-->
    <Setting v-if="activeName == 'second'"></Setting>
    <!--拉新设置-->
    <DirectRecommend v-if="activeName == 'DirectRecommend' && show_DirectRecommend == true"></DirectRecommend>

  </div>
</template>
<script>
import Setting from './part/Setting';
import Log from './part/Log';
import DirectRecommend from './part/DirectRecommend';
export default {
  components: {
    Setting,
    Log,
    DirectRecommend
  },
  data() {
    return {
      form: {
        status: 0
      },
      activeName: 'first',
      show_DirectRecommend: false,
    };
  },
  created() {
    /*权限检测*/
    if(this.$filter.isAuth('/user/points/part/DirectRecommend'))  this.show_DirectRecommend = true;
  },
  methods: {}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/user/points/index.vue